export default "__VITE_ASSET__abc5dac3__"